import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";

import { PortalRoutesWrapper } from "@/app/components/auth";
import { ROUTES } from "@/app/router";
import {
  CoachingHub,
  ScheduleDietitianScreen,
  ScheduleJourneySupport,
} from "@/features/coaching/screens";
import { CoachingRoutesWrapper } from "./routes-wrapper";

export const getCoachingRoute = (): RouteObject => ({
  path: ROUTES.COACHING.OVERVIEW,
  element: <PortalRoutesWrapper />,

  children: [
    {
      element: <CoachingRoutesWrapper />,
      children: [
        {
          index: true,
          element: <CoachingHub />,
        },
        {
          path: `${ROUTES.COACHING.JOURNEY_SUPPORT_SCHEDULE}/:appointmentId?`,
          element: <ScheduleJourneySupport />,
        },
        {
          path: `${ROUTES.COACHING.DIETITIAN_SCHEDULE}/:appointmentId?`,
          element: <ScheduleDietitianScreen />,
        },
        // {
        //   path: ROUTES.COACHING.PAST_APPOINTMENTS,
        //   element: <PastAppointments />,
        // },

        {
          path: "*",
          element: <Navigate replace to={ROUTES.COACHING.OVERVIEW} />,
        },
      ],
    },
  ],
});
